/** @return whether the text reached the clipboard */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return copyWithExecCommand(text)
  }
}

function copyWithExecCommand(text: string) {
  const textArea = document.createElement("textarea")
  textArea.value = text
  textArea.readOnly = true
  textArea.style.position = "fixed"
  textArea.style.opacity = "0"
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    return document.execCommand("copy")
  } catch {
    return false
  } finally {
    textArea.remove()
  }
}
